import { useState } from "react";

import { makeGetApiCall } from "../../shared/makeApiCall";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";
import { convertToTwoDecimals } from "../../shared/utility";

export function BarcodeHistoryViewModel(logout) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [product, setProduct] = useState({
    serial: null,
    on_hand_net_kg: null,
    statusReason: null,
    stock_unit_of_measurement: null,
    on_hand_piece_count: null,
    name: null,
    name_ch: null,
    created_date: null,
    barcode: null,
    barcode_histories: null,
    id: null,
    itemType: null,
  });

  const getBarcodeHistory = async function (barcode) {
    if (barcode.trim().length === 0) {
      showErrorModal("Barcode cannot be empty");
      return;
    }
    setLoading(true);
    let callResult = await makeGetApiCall(`barcodeHistory/${barcode}`, {});

    if (callResult.success) {
      setTimeout(function () {
        if (callResult.data.type === "pallet") {
          setProduct({
            id: callResult.data.pallet.id,
            itemType: "pallet",
            serial: callResult.data.pallet.serial,
            plu: callResult.data.pallet.plu,
            on_hand_net_kg: convertToTwoDecimals(
              callResult.data.pallet.on_hand_net_kg
            ),
            statusReason: callResult.data.pallet.statusReason,
            stock_unit_of_measurement:
              callResult.data.pallet.stock_unit_of_measurement,
            on_hand_piece_count: convertToTwoDecimals(
              callResult.data.pallet.on_hand_piece_count,
              0
            ),
            name: callResult.data.pallet.product_name,
            name_ch: callResult.data.pallet.product_name_ch,
            lot_number: callResult.data.pallet.lot_number,
            created_date: callResult.data.pallet.created_date,
            lastScanDate: callResult.data.pallet.lastScanDate,
            barcode: callResult.data.pallet.barcode,
            barcode_histories: callResult.data.barcode_histories,
            warehouse_location_name:
              callResult.data.pallet.warehouse_location_name,
            total_cartons: callResult.data.pallet.total_cartons,
            inv_on_hand_by_plu: callResult.data.pallet.inv_on_hand_by_plu,
            inv_on_hand_by_lot: callResult.data.pallet.inv_on_hand_by_lot,
          });
        } else {
          setProduct({
            id: callResult.data.manufactured_item.id,
            itemType: "manufactured",
            serial: callResult.data.manufactured_item.serial,
            plu: callResult.data.manufactured_item.plu,
            on_hand_net_kg: convertToTwoDecimals(
              callResult.data.manufactured_item.on_hand_net_kg
            ),
            statusReason: callResult.data.manufactured_item.statusReason,
            stock_unit_of_measurement:
              callResult.data.manufactured_item.stock_unit_of_measurement,
            on_hand_piece_count: convertToTwoDecimals(
              callResult.data.manufactured_item.on_hand_piece_count,
              0
            ),
            name: callResult.data.manufactured_item.product_name,
            name_ch: callResult.data.manufactured_item.product_name_ch,
            lot_number: callResult.data.manufactured_item.lot_number,
            created_date: callResult.data.manufactured_item.created_date,
            lastScanDate: callResult.data.manufactured_item.lastScanDate,
            barcode: callResult.data.manufactured_item.barcode,
            barcode_histories: callResult.data.barcode_histories,
            warehouse_location_name:
              callResult.data.manufactured_item.warehouse_location_name,
            total_cartons: 1,
            inv_on_hand_by_plu:
              callResult.data.manufactured_item.inv_on_hand_by_plu,
            inv_on_hand_by_lot:
              callResult.data.manufactured_item.inv_on_hand_by_lot,
          });
        }
      }, 250);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    setLoading(false);
  };

  const showErrorModal = (subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title="Error"
        />
      ),
      open: true,
    });
  };

  // async function reprintLabel() {
  //   return axios.post("http://192.168.2.248:9100", {
  //     plu: "0108",
  //     name_en: "#1 Cull Slice XL (Bulk)",
  //     name_ch: "筛花皮参片(特大) 散装",
  //     lot_number: "2573647656",
  //     tare_weight: "10.2",
  //     best_before_date: "2025-05-19",
  //     piece_count: "100",
  //     weight_in_kg: "37.82KG",
  //     weight_in_lbs: "79.14LBS",
  //     barcode_str: "0154861755080851112507023102002000215679280005",
  //     label_image_zpl: "",
  //     is_sample: false,
  //     last_9: "000215679",
  //     sample: "",
  //   });
  // }

  const tsplCommand = `
SIZE 100 mm, 150 mm
CLS
TEXT 100,100,"TSS24.BF2",0,2,2,"Hello Vretti"
PRINT 1
`;

  async function reprintLabel() {
    await window.qz.websocket.connect();

    const config = window.qz.configs.create(null);
    config.host = "192.168.2.248";
    config.port = 9100;
    config.useSocket = true;

    await window.qz.print(config, [
      {
        type: "raw",
        format: "plain",
        data: tsplCommand,
      },
    ]);

    await window.qz.websocket.disconnect();
  }

  // const reprintLabel = async function () {
  //   let callResult = await makePostApiCallToPrinter({
  //     plu: "0108",
  //     name_en: "#1 Cull Slice XL (Bulk)",
  //     name_ch: "筛花皮参片(特大) 散装",
  //     lot_number: "2573647656",
  //     tare_weight: "10.2",
  //     best_before_date: "2025-05-19",
  //     piece_count: "100",
  //     weight_in_kg: "37.82KG",
  //     weight_in_lbs: "79.14LBS",
  //     barcode_str: "0154861755080851112507023102002000215679280005",
  //     label_image_zpl: "",
  //     is_sample: false,
  //     last_9: "000215679",
  //     sample: "",
  //   });

  //   if (callResult.success) {
  //   } else {
  //     if (callResult.errorStatus === 401) {
  //       logout();
  //     }
  //     showErrorModal(callResult.data.message);
  //   }
  // };

  return {
    product,
    getBarcodeHistory,
    loading,
    emptyModal,
    setEmptyModelOpen,
    reprintLabel,
  };
}
